<template>
  <div>
    {{ $t("custom.results_per_page") }}

    <button
      class="-mx-px ml-2 h-9 w-10 rounded-l border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[activeItems === 15 ? 'bg-[var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium']"
      type="button"
      @click="$emit('update:itemsPerPage', 15)"
    >
      15
    </button>
    <button
      class="-mx-px h-9 w-10 border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[activeItems === 30 ? 'bg-[var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium']"
      type="button"
      @click="$emit('update:itemsPerPage', 30)"
    >
      30
    </button>
    <button
      class="-mx-px h-9 w-10 rounded-r border border-solid border-gray-300 text-center text-sm uppercase"
      :class="[activeItems === 45 ? 'bg-[var(--color-primary-500)] font-bold text-white' : 'bg-white font-medium']"
      type="button"
      @click="$emit('update:itemsPerPage', 45)"
    >
      45
    </button>
  </div>
</template>

<script setup lang="ts">
import { DEFAULT_PAGE_SIZE } from "@/core/constants";

defineProps({
  loading: Boolean,

  activeItems: {
    type: Number,
    default: DEFAULT_PAGE_SIZE,
  },
});
</script>
